<div class="w-full">
  <div class="flex flex-col">
    @if(showLabel){
      <label class="fixed-lable-style">{{ label }}</label>
      <p-select [options]="options" [(ngModel)]="selectedValue" (onChange)="onValueChange($event)" id="label"
        class="min-w-[{{customWidth}}] min-h-[45px] " [required]="required" [disabled]="isDisabledState"
        [class.readonly-dropdown]="isDisabledState">
      </p-select>
      }@else{
      <p-floatLabel>
        <p-select [options]="options" [(ngModel)]="selectedValue" (onChange)="onValueChange($event)" id="label"
          class="min-w-[250px] min-h-[45px] " [required]="required" [disabled]="isDisabledState"
          [class.readonly-dropdown]="isDisabledState">
        </p-select>
        <label [for]="label"> {{ label }}</label>
      </p-floatLabel>
    }
  </div>
  @if ((required && (touched || isFormSubmitted) && !selectedValue)) {
    <div class="text-danger">
      {{ validationName ? validationName + ' is required' : 'This field is required' }}
    </div>
  }
</div>